import { computed, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import {
  PaginatedApiResponse,
  PaginationMeta,
} from '../../../core/models/pagination.model';

export interface Notification {
  id: number;
  title: string;
  message: string;
  seen: boolean;
  create_time: string;
  created_at: string;
  action_type?: number;
  action_data?: {
    item_type?: any;
    item_id?: number;
  };
}

/**
 class CharityNotificationObjectPageActionDataTypes(ChoiceEnum):
    PRE_ASSESSMENT_STATUS_CHANGED = 1, 'Pre Assessment Status Changed'
    ASSESSMENT_STATUS_CHANGED = 2, 'Assessment Status Changed'
    CERTIFICATE_EXPIRY_REMINDER = 3, 'Charity Certificate Expiry Reminder'
    EVALUATION_COMPLETED = 4, 'Charity Evaluation Completed'
    EVALUATION_REMINDER = 5, 'Evaluation Assessment Reminder'
    NEW_TRAINING_CANDIDATE = 6, 'New Training Candidate Registered'
    WORKSHOP_REGISTERING = 7, 'Workshop Registering'
    E_WORKSHOP_UPLOADED = 8, 'E-Workshop Uploaded'
 */

export enum CharityNotificationObjectPageActionDataTypes {
  PRE_ASSESSMENT_STATUS_CHANGED = 1,
  ASSESSMENT_STATUS_CHANGED = 2,
  CERTIFICATE_EXPIRY_REMINDER = 3,
  EVALUATION_COMPLETED = 4,
  EVALUATION_REMINDER = 5,
  NEW_TRAINING_CANDIDATE = 6,
  WORKSHOP_REGISTERING = 7,
  E_WORKSHOP_UPLOADED = 8,
}

export interface Message {
  id: number;
  title: string;
  body: string;
  seen: boolean;
  create_time: string;
  created_at: string;
}

export interface NotificationsResponse extends PaginatedApiResponse<
  Notification[]
> {}

export interface MessagesResponse extends PaginatedApiResponse<Message[]> {}

@Injectable({
  providedIn: 'root',
})
export class NotifsAndMessagesService {
  private baseUrl: string = environment.baseApi;

  constructor(private http: HttpClient) {}

  getMessages(
    page: number = 1,
    params?: Record<string, any>,
  ): Observable<MessagesResponse> {
    return this.http.get<MessagesResponse>(`${this.baseUrl}messages/`, {
      params: {
        page: page,
      },
    });
  }

  getNotifications(
    page: number = 1,
    params?: Record<string, any>,
  ): Observable<NotificationsResponse> {
    return this.http.get<NotificationsResponse>(
      `${this.baseUrl}notifications/`,
      {
        params: {
          page: page,
        },
      },
    );
  }

  markNotificationAsSeen(id: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}notifications/see/${id}/`, {}),
    );
  }

  deleteNotification(id: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}notifications/delete/${id}/`),
    );
  }

  deleteAllNotifications(lastFetchedId: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}notifications/delete-all/`, {
        body: { last_fetched_id: lastFetchedId },
      }),
    );
  }

  seeAllNotifications(lastFetchedId: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}notifications/see-all/`, {
        last_fetched_id: lastFetchedId,
      }),
    );
  }

  markMessageAsSeen(id: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}messages/see/${id}/`, {}),
    );
  }

  deleteMessage(id: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}messages/delete/${id}/`),
    );
  }

  deleteAllMessages(lastFetchedId: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}messages/delete-all/`, {
        body: { last_fetched_id: lastFetchedId },
      }),
    );
  }

  seeAllMessages(lastFetchedId: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}messages/see-all/`, {
        last_fetched_id: lastFetchedId,
      }),
    );
  }

  getMessageById(id: number) {
    return firstValueFrom(this.http.get(`${this.baseUrl}messages/${id}/`));
  }
}
/**
 * ###

GET {{ROOT}}/messages/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/messages/delete/3018/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/messages/delete-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 3017
}

###
PATCH {{ROOT}}/messages/see/3017/
Authorization: Bearer {{auth_token}}


###
PATCH {{ROOT}}/messages/see-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 3017
}

###
GET {{ROOT}}/messages/3019/
Authorization: Bearer {{auth_token}}
Content-Type: application/json




 */
